import { registerGtmDataLayer } from '../../../../../Features/Blocks/Video/gtmDataLayerService';

export default async function (body, formularInformation, url, isCustomer, requestVerificationToken, recaptchaToken) {
  const boolToYesNo = (value) => value == undefined
    ? "not_applicable"
    : value
      ? "Yes"
      : "No";

  const api = window.location.origin + "/" + url
  const response = await fetch(api, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      "RequestVerificationToken": requestVerificationToken,
      "RecaptchaToken": recaptchaToken
    },
  })
    .then((res) => {
      if (res.ok) {
        let dataLayer = {
          'event': 'track-event.nyhedsbrev_submit',
          'event_source': 'inline',
          'eventCategory': 'newsletter',
          'eventAction': 'submit',
          'eventLabel': body.newsletters
        };

        registerGtmDataLayer(dataLayer);

        const contentType = res.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          return res.json();
        } else {
          return res.text();
        }
      } else {
        throw new Error("Didn't work submitting the form signing up for one or more newsletters.")
      }
    })
    .then((json) => {
      return json
    })
    .catch((err) => {
      console.error(err)
      return err
    })

  if (response && response.name && response.email) {
    let dataLayer = {
      'event': 'track-immeo.permission_signup',
      'form_id': formularInformation.formId,
      'form_name': formularInformation.formName,
      'form_type': 'userdata',
      'userExistingClient': boolToYesNo(isCustomer),
      'eventCategory': 'permission',
      'eventAction': 'submit',
      'eventLabel': formularInformation.formName,
      'payload': {
        'user_firstname': response.name,
        'user_lastname': response.lastname,
        'user_email': response.email,
        'user_phone': response.phonenumber
      }
    };

    registerGtmDataLayer(dataLayer);
  }
  return response
}
